import React from "react";

const Text = ({ text, amount = null }) => {
  return (
    <p className="cursor-pointer font-pop text-sm font-normal text-darkGreen opacity-60">
      {text} {amount && ` (${amount})`}
    </p>
  );
};

export default Text;
